import React from 'react';
export default function PhoenixHelmSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="flameGrad" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0%" stopColor="#FF6F00" />
          <stop offset="50%" stopColor="#FFC107" />
          <stop offset="100%" stopColor="#FFF176" />
        </linearGradient>
        <linearGradient id="helmGold" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FFD54F" />
          <stop offset="100%" stopColor="#F57F17" />
        </linearGradient>
      </defs>

      {/* Flame plume - back layer */}
      <path d="M20 2 C16 8 12 6 14 14 C16 10 18 12 20 6 C22 12 24 10 26 14 C28 6 24 8 20 2Z" fill="url(#flameGrad)" opacity="0.6" />

      {/* Flame plume - front layer */}
      <path d="M20 4 C18 9 16 8 17 14 C18 11 19 12 20 8 C21 12 22 11 23 14 C24 8 22 9 20 4Z" fill="#FFF176" opacity="0.7" />

      {/* Helmet dome */}
      <path d="M6 32 C6 18 10 12 20 12 C30 12 34 18 34 32 Z" fill="url(#helmGold)" />

      {/* Helmet brim */}
      <ellipse cx="20" cy="32" rx="16" ry="4" fill="#E65100" />
      <ellipse cx="20" cy="31" rx="15" ry="3" fill="#F57F17" />

      {/* Visor opening */}
      <path d="M12 24 C12 22 16 20 20 20 C24 20 28 22 28 24 L26 28 C24 30 16 30 14 28 Z" fill="#3E2723" />

      {/* Gold wing ornaments on sides */}
      <path d="M6 24 L2 18 L4 22 L1 16 L6 22" fill="#FFB300" />
      <path d="M34 24 L38 18 L36 22 L39 16 L34 22" fill="#FFB300" />

      {/* Center crest gem */}
      <circle cx="20" cy="16" r="2.5" fill="#FF5722" />
      <circle cx="20" cy="16" r="1.5" fill="#FFAB91" />

      {/* Animated flame flicker */}
      <circle cx="18" cy="5" r="0.8" fill="#FFF176" opacity="0.7">
        <animate attributeName="opacity" values="0.3;0.9;0.3" dur="0.8s" repeatCount="indefinite" />
      </circle>
      <circle cx="22" cy="3" r="0.6" fill="#FFF176" opacity="0.5">
        <animate attributeName="opacity" values="0.5;1;0.5" dur="1.2s" repeatCount="indefinite" />
      </circle>
    </svg>
  );
}
